<template>
  <div class="contract-info">
    <div class="mp-records-tabs">
      <div
        v-for="item in tabs"
        :key="item.id"
        class="mp-records-tab"
        :class="{ 'mp-records-tab_active': tab == item.id }"
        @click="changeTab(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <list
      ref="list"
      url="/api/app/arrange/periods"
      :search="{ type: tab }"
      @page-load="onListLoad"
    >
      <template v-slot="{ list }">
        <template v-if="tab == 1">
          <!--            一对一在这里判断-->
          <div v-for="(data, ind) in list" :key="ind" class="contract">
            <div class="oto-item">
              <div class="out-line-head">
                <img src="../../../images/contracts.png" class="img" />
                <div class="info">
                  <div class="info-title">
                    {{ data.contracts_number }}
                  </div>
                  <div class="info-in">
                    <span class="info-class">
                      签约时间：
                      <span class="info-class-it">
                        {{ data.sign_time | tsFormatDate }}
                      </span>
                    </span>
                    <span class="info-class">
                      教学分类：
                      <span class="info-class-it">
                        {{ data.classify_name }}
                      </span>
                    </span>
                    <span class="info-class" v-if="data.grade_name">
                      年级：
                      <span class="info-class-it">
                        {{ data.grade_name }}
                      </span>
                    </span>
                    <span class="info-class">
                      状态：
                      <span
                        class="info-class-it"
                        :class="`status-${data.status}`"
                        v-if="data.status == 1"
                      >
                        未执行
                      </span>
                      <span
                        class="info-class-it"
                        :class="`status-${data.status}`"
                        v-if="data.status == 2"
                      >
                        使用中
                      </span>
                      <span
                        class="info-class-it"
                        :class="`status-${data.status}`"
                        v-if="data.status == 3"
                      >
                        已结束
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <el-table :data="data.items" style="width: 100%">
              <el-table-column
                prop="subject_name"
                label="科目"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="periods_num"
                label="总课时"
              ></el-table-column>
              <el-table-column
                prop="consume_periods_num"
                label="已用"
              ></el-table-column>
              <el-table-column
                prop="refund_periods_num"
                label="已退款"
              ></el-table-column>
              <el-table-column
                prop="refund_doing_periods"
                label="退款中"
              ></el-table-column>
              <el-table-column
                prop="left_periods_num"
                label="可用"
              ></el-table-column>
              <el-table-column label="指定讲师" width="120px">
                <template slot-scope="scope">
                  <div
                    class="ellipsis"
                    v-if="scope.row.teachers && scope.row.teachers.length > 0"
                  >
                    {{ scope.row.teachers.join("/") }}
                  </div>
                  <template v-else>-</template>
                </template>
              </el-table-column>
              <el-table-column label="大纲">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    v-if="scope.row.is_set_chapters == 1"
                    @click="$emit('showOutLine', scope.row)"
                  >
                    查看
                  </el-button>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="data.status == 2">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    v-if="scope.row.left_periods_num > 0"
                    @click="goTo(scope.row)"
                  >
                    去约课
                  </el-button>
                  <div v-else>-</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <EmptyNew v-if="list.length == 0" title="暂无数据"></EmptyNew>
        </template>
        <template v-else>
          <el-table :data="list" style="width: 100%">
            <el-table-column
              v-if="$store.state.commonSetting.switch_sch_attr_classify == 1"
              prop="classify_name"
              label="分类"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="grade_name"
              v-if="$store.state.commonSetting.switch_sch_attr_grade == 1"
              label="年级"
            ></el-table-column>
            <el-table-column
              prop="subject_name"
              label="科目"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="periods_num"
              label="总课时"
            ></el-table-column>
            <el-table-column
              prop="consume_periods_num"
              label="已用"
            ></el-table-column>
            <el-table-column
              prop="refund_periods_num"
              label="已退款"
            ></el-table-column>
            <el-table-column
              prop="refund_doing_periods"
              label="退款中"
            ></el-table-column>
            <el-table-column
              prop="left_periods_num"
              label="可用"
            ></el-table-column>
          </el-table>
        </template>
      </template>
    </list>
  </div>
</template>
<script>
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberPeriodsRecord",
  components: { EmptyNew },
  data() {
    return {
      tab: 0,
      extra: {},
    };
  },
  computed: {
    tabs() {
      let tabs = [];
      let number = 0;
      if (this.extra.ono_ono == 1) {
        tabs.push({
          id: 1,
          name: "一对一课时包",
        });
        number++;
      }
      if (this.extra.ono_more == 1) {
        tabs.push({
          id: 2,
          name: "一对多课时包",
        });
        number++;
      }
      if (this.extra.class == 1) {
        tabs.push({
          id: 3,
          name: "班课课时包",
        });
        number++;
      }
      if (number > 1) {
        return tabs;
      } else {
        return [];
      }
    },
  },
  async created() {
    await this.getContractType();
    this.judgeCurTab();
  },
  methods: {
    //去约课
    goTo(row) {
      this.$router.push({
        name: "ShowAppointmentTeachers",
        query: {
          course_classify_id: row.course_classify_id,
          grade_id: row.grade_id,
          subject_id: row.subject_id,
        },
      });
    },
    onListLoad() {
      triggerLoaded(this);
    },
    async getContractType() {
      let data = await this.$http.get("/api/app/arrange/contract/type");
      this.extra = data;
    },
    changeTab(tab) {
      this.tab = tab;
      this.$refs.list.searchRefresh();
    },
    judgeCurTab() {
      if (this.extra.ono_ono == 1) {
        this.tab = 1;
        this.$refs.list.searchRefresh();
        return;
      }
      if (this.extra.ono_more == 1) {
        this.tab = 2;
        this.$refs.list.searchRefresh();
        return;
      }
      if (this.extra.class == 1) {
        this.tab = 3;
        this.$refs.list.searchRefresh();
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contract-info {
  /deep/ .el-table__header-wrapper {
    th {
      background: #f7f7f7 !important;
    }
    th.is-leaf {
      border: none;
    }
    th .cell {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600 !important;
    }
  }
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
}
.mp-records-tabs {
  display: flex;
  font-size: 14px;
  color: #999999;
  margin-bottom: 18px;
  line-height: 1;
}
.mp-records-tab {
  padding: 0 14px;
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 17px;
    background: #d9d9d9;
    right: 0;
    top: 2px;
  }

  &:first-child {
    padding-left: 0;
  }

  &:last-child::after {
    display: none;
  }
}
.mp-records-tab_active {
  color: $primary-color;
  font-family: PingFang SC Medium, PingFang SC Medium-Medium;
  font-weight: 500;
}
.mp-records-table {
  width: 100%;
  font-size: 14px;

  th {
    background: #f8f8f8;
    height: 44px;
  }

  th,
  td {
    text-align: left;
  }

  th:nth-child(1),
  td:nth-child(1) {
    padding-left: 16px;
  }

  th:last-child,
  td:last-child {
    padding-right: 16px;
  }

  th:nth-last-child(1),
  th:nth-last-child(2),
  th:nth-last-child(3),
  th:nth-last-child(4),
  th:nth-last-child(5),
  td:nth-last-child(1),
  td:nth-last-child(2),
  td:nth-last-child(3),
  td:nth-last-child(4),
  td:nth-last-child(5) {
    text-align: right;
    width: 100px;
  }

  td {
    border-bottom: 1px solid #ededed;
    padding: 12px 0;
  }
}
.contract {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.out-line-head {
  margin: 6px 0 16px 0;
  display: flex;
  .img {
    width: 47px;
    height: 47px;
    margin-right: 16px;
  }
  .info-title {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #000000;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    width: 800px;
  }
  .info-in {
    margin-top: 8px;
  }
  .info-class {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    display: inline-block;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    width: 200px;
    .info-class-it {
      color: #333;
    }
    .status-1 {
      color: #333;
    }
    .status-2 {
      color: #1dcc66;
    }
    .status-3 {
      color: #ff2424;
    }
    &:last-child {
      display: inline-block;
      //margin-right: 0;
    }
  }
}
</style>
